module.exports = __webpack_public_path__ + "files/e0616b84c94ed19f61d0053ec0e2a459.png";